import { render } from "./MFAForm.vue?vue&type=template&id=4479edd2"
import script from "./MFAForm.vue?vue&type=script&lang=js"
export * from "./MFAForm.vue?vue&type=script&lang=js"

import "./MFAForm.vue?vue&type=style&index=0&id=4479edd2&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__